export default {
  de:
    "Hallo! Ich habe die folgenden schweren Allergien und würde mich sehr freuen, wenn Sie mir das Essen zeigen könnten, das ich gefahrlos essen kann.",
  el: "Γειά σου! Έχω τις ακόλουθες σοβαρές αλλεργίες και θα εκτιμούσα αν μου δείχνατε ποια τροφή μπορώ να φάω με ασφάλεια.",
  en:
    "Hello! I have the following severe allergies and would appreciate if you would show me what food I can safely eat.",
  ar:
    "مرحبا! لدي الحساسية الشديدة التالية ، وسأكون ممتنا إذا كنت سوف تظهر لي ما يمكنني أكل الطعام بأمان.",
  fr:
    "salut! J'ai les allergies sévères suivantes et j'apprécierais que vous me montriez quelle nourriture je peux manger en toute sécurité.",
  zh:
    "你好！ 我有以下严重的过敏症，如果你能告诉我可以安全食用的食物，我将不胜感激。",
  es:
    "¡Hola! Tengo las siguientes alergias graves, y le agradecería que me contara acerca de los alimentos que puedo comer con seguridad.",
  it:
    "Salve! Ho le seguenti gravi allergie e le sarei grato se mi mostrasse che cosa posso mangiare in sicurezza."
};



// WEBPACK FOOTER //
// ./src/data_intro.js